import React, { useState ,useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Layout from "../../components/layouts/Layout";
import TableLive from "./liveEvent/TableLive";
import TablePast from "./pastEvent/TablePast";
import TableUpcoming from "./upcomingEvent/TableUpcoming";
import './style/style.css'
import DraftProduct from "./createEvent/Draft/DraftProduct";
import LocalStorage from "../../hook/LocalStorage";
const Event = () => {

	const history = useHistory()
	const {type} = useParams()
	const { user } = LocalStorage()
	const [eventStatus, setStatus] = useState("live")


		// if (eventStatus === 'live') {
		// 	history.push('/event/live')
		// }else if(eventStatus === 'past'){
			
		// }else if(eventStatus === 'upcoming'){
		// 	history.push('/event/upcoming')
		// }else if(eventStatus === 'draft'){
		// 	history.push('/event/draft')
		// }

		// if (eventStatus === 'draft') {
		// 	history.push('/event/draft')
		// }
		// else if (eventStatus === 'past') {
		// 	history.push({
		// 		pathname: '/event/past',
        //  		search: `?user_id=${user.id}&per_page=${6}`,
		// 	})
		// }
		// else if (eventStatus === 'upcoming') {
		// 	history.push('/event/upcoming')
		// }
		// else{
		// 	history.push('/event/live')
		// }


	return (
		<Layout>
			<div className="card radius-10">
				<div className="card-body">
					<div className="row">
						<div className="col-12">
							<div className="tab-items-section">
								<div className="section-tab-status">
									<p className="text-secondary">Status :</p>
								</div>
								<div className="section-tab-body">
									<div className="tab-body">
										<div className="tab-items">
											<span
												className={history.location.hash == '#live' &&`active`}
												onClick={()=> history.push({
													hash: '#live',
												})}
											>Live Events</span>
										</div>
										<div className="tab-items">
											<span
												className={history.location.hash == '#upcoming' &&`active`}
												onClick={() => history.push({
													hash: '#upcoming',
												})}
											>Future Events</span>
										</div>

										<div className="tab-items">
											<span
												className={history.location.hash == '#past' &&`active`}
												onClick={ () => history.push({
													hash: '#past',
													search: `?user_id=${user.id}&per_page=${6}`,
												})}
											>Past Events</span>
										</div>

										<div className="tab-items">
											<span
												className={history.location.hash == '#draft' &&`active`}
												onClick={ ()=> history.push({
													hash: '#draft',
												})}
											>Draft Events</span>
										</div>

									</div>
								</div>
							</div>
						</div>
						<div className="col-12">
							
						</div>
					</div>
					<div className="tab-content" id="pills-tabContent">
						<div
							className={`tab-pane fade ${history.location.hash == '#live' ? `show active` : ''}`}
							id="pills-home"
							role="tabpanel"
							aria-labelledby="pills-home-tab"
						>
							<TableLive />
						</div>
						<div
							className={`tab-pane fade ${history.location.hash == '#upcoming' ? `show active`:''}`}
							id="pills-profile"
							role="tabpanel"
							aria-labelledby="pills-profile-tab"
						>
							<TableUpcoming />
						</div>
						<div
							className={`tab-pane fade ${history.location.hash == '#past' ? `show active`:''}`}
							id="pills-contact"
							role="tabpanel"
							aria-labelledby="pills-contact-tab"
						>
							<TablePast />
						</div>

						<div
							className={`tab-pane fade ${history.location.hash == '#draft' ? `show active`:''}`}
							id="pills-contact"
							role="tabpanel"
							aria-labelledby="pills-contact-tab"
						>
							<DraftProduct />
						</div>

					</div>
				</div>
			</div>
		</Layout>
	);
};

export default Event;
